import { all, call, fork, put, takeEvery } from 'redux-saga/effects'
import API, { auth } from '../../constants/api'
import {
  REGISTER_EMAIL,
  ACTIVATE_TOKEN,
  GET_TOKEN_LINE,
  VERIFY_TOKEN_LINE,
  GET_TOKEN_LINE_MOBILE,
  VERIFY_TOKEN_LINE_MOBILE
} from '../actions'

import {
  registeremailFetchSuccess,
  registeremailFetchFail,
  activateTokenFetchSuccess,
  activateTokenFetchFail,
  getTokenlineFetchSuccess,
  getTokenlineFetchFail,
  verifyTokenlineFetchSuccess,
  verifyTokenlineFetchFail,
  getTokenlineMobileFetchSuccess,
  getTokenlineMobileFetchFail,
  verifyTokenlineMobileFetchSuccess,
  verifyTokenlineMobileFetchFail
} from './actions'

/* register email */
const registeremailFetchAsync = async (req) =>
  await API.post('/auth/' + req.actionType, {
    "registerType": req.registerType,
    "memberPrefix": req.memberPrefix,
    "memberFname": req.memberFname,
    "memberLname": req.memberLname,
    "provinceId": req.provinceId,
    "memberEmail": req.memberEmail,
    "password": req.password,
    "socialId": req.socialId,
    "memberTel": req.memberTel,
    "memberAvatar": req.memberAvatar,
    "token": req.sessionToken
  },
    {
      headers: auth
    }
  )
    .then((data) => data)
    .catch((error) => error)

function* registeremailFetch({ payload }) {
  const { registerEmail } = payload
  // console.log('registerEmail -> ', registerEmail)
  try {
    const registeremailFetch = yield call(registeremailFetchAsync, registerEmail)

    if (registeremailFetch.data.StatusCode === '0000') {
      yield put(registeremailFetchSuccess(registeremailFetch.data.ResultValues))
    } else {
      yield put(registeremailFetchFail(registeremailFetch.data.Message))
    }
  } catch (error) {
    yield put(registeremailFetchFail(error))
  }
}

/* activate token */
const activateTokenFetchAsync = async (req) =>
  await API.post('/auth/' + req.actionType, {
    "token": req.token
  },
    {
      headers: auth
    }
  )
    .then((data) => data)
    .catch((error) => error)

function* activateTokenFetch({ payload }) {
  const { activateToken } = payload
  // console.log('activateToken -> ', activateToken)
  try {
    const activateTokenFetch = yield call(activateTokenFetchAsync, activateToken)

    if (activateTokenFetch.data.StatusCode === '0000') {
      yield put(activateTokenFetchSuccess(activateTokenFetch.data.ResultValues))
    } else {
      yield put(activateTokenFetchFail(activateTokenFetch.data.Message))
    }
  } catch (error) {
    yield put(activateTokenFetchFail(error))
  }
}

/* get token line */
const getTokenlineFetchAsync = async (req, domain) =>
  await API.post('https://api.line.me/oauth2/v2.1/token',
    new URLSearchParams({
      "grant_type": 'authorization_code',
      "code": req.code,
      "client_id": '1657472842',
      "client_secret": 'dcce14490c4bb1e3d1bd39f7c1bb0f0e',
      "code_verifier": 'wJKN8qz5t8SSI9lMFhBB6qwNkQBkuPZoCxzRhwLRUo1',
      "redirect_uri": domain + '/user/login-line'
    }),
    {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }
  )
    .then((data) => data)
    .catch((error) => error)

function* getTokenlineFetch({ payload }) {
  const { getTokenline } = payload
  // console.log('getTokenline -> ', getTokenline)
  let domain = window.location.origin;
  try {
    const getTokenlineFetch = yield call(getTokenlineFetchAsync, getTokenline, domain)
    // console.log('getTokenlineFetch -> ', getTokenlineFetch)
    if (getTokenlineFetch.status === 200) {
      yield put(getTokenlineFetchSuccess(getTokenlineFetch.data.id_token))
    } else {
      yield put(getTokenlineFetchFail('Error'))
    }
  } catch (error) {
    yield put(getTokenlineFetchFail(error))
  }
}

/* verify token line */
const verifyTokenlineFetchAsync = async (req) =>
  await API.post('https://api.line.me/oauth2/v2.1/verify',
    new URLSearchParams({
      "id_token": req.id_token,
      "client_id": '1657472842'
    }),
    {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }
  )
    .then((data) => data)
    .catch((error) => error)

function* verifyTokenlineFetch({ payload }) {
  const { verifyTokenline } = payload
  // console.log('verifyTokenline -> ', verifyTokenline)
  try {
    const verifyTokenlineFetch = yield call(verifyTokenlineFetchAsync, verifyTokenline)
    // console.log('verifyTokenlineFetch -> ', verifyTokenlineFetch)
    if (verifyTokenlineFetch.status === 200) {
      yield put(verifyTokenlineFetchSuccess(verifyTokenlineFetch.data))
    } else {
      yield put(verifyTokenlineFetchFail('Error'))
    }
  } catch (error) {
    yield put(verifyTokenlineFetchFail(error))
  }
}

/* get token line */
const getTokenlineMobileFetchAsync = async (req, domain) =>
  await API.post('https://api.line.me/oauth2/v2.1/token',
    new URLSearchParams({
      "grant_type": 'authorization_code',
      "code": req.code,
      "client_id": '1657472842',
      "client_secret": 'dcce14490c4bb1e3d1bd39f7c1bb0f0e',
      "code_verifier": 'wJKN8qz5t8SSI9lMFhBB6qwNkQBkuPZoCxzRhwLRUo1',
      "redirect_uri": domain + '/user/login-line-mobile'
    }),
    {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }
  )
    .then((data) => data)
    .catch((error) => error)

function* getTokenlineMobileFetch({ payload }) {
  const { getTokenlineMobile } = payload
  // console.log('getTokenlineMobile -> ', getTokenlineMobile)
  let domain = window.location.origin;
  try {
    const getTokenlineMobileFetch = yield call(getTokenlineMobileFetchAsync, getTokenlineMobile, domain)
    // console.log('getTokenlineMobileFetch -> ', getTokenlineMobileFetch)
    if (getTokenlineMobileFetch.status === 200) {
      yield put(getTokenlineMobileFetchSuccess(getTokenlineMobileFetch.data.id_token))
    } else {
      yield put(getTokenlineMobileFetchFail('Error'))
    }
  } catch (error) {
    yield put(getTokenlineMobileFetchFail(error))
  }
}

/* verify token line */
const verifyTokenlineMobileFetchAsync = async (req) =>
  await API.post('https://api.line.me/oauth2/v2.1/verify',
    new URLSearchParams({
      "id_token": req.id_token,
      "client_id": '1657472842'
    }),
    {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }
  )
    .then((data) => data)
    .catch((error) => error)

function* verifyTokenlineMobileFetch({ payload }) {
  const { verifyTokenlineMobile } = payload
  // console.log('verifyTokenlineMobile -> ', verifyTokenlineMobile)
  try {
    const verifyTokenlineMobileFetch = yield call(verifyTokenlineMobileFetchAsync, verifyTokenlineMobile)
    // console.log('verifyTokenlineMobileFetch -> ', verifyTokenlineMobileFetch)
    if (verifyTokenlineMobileFetch.status === 200) {
      yield put(verifyTokenlineMobileFetchSuccess(verifyTokenlineMobileFetch.data))
    } else {
      yield put(verifyTokenlineMobileFetchFail('Error'))
    }
  } catch (error) {
    yield put(verifyTokenlineMobileFetchFail(error))
  }
}

export function* watchRegisterFetch() {
  yield takeEvery(REGISTER_EMAIL, registeremailFetch)
  yield takeEvery(ACTIVATE_TOKEN, activateTokenFetch)
  yield takeEvery(GET_TOKEN_LINE, getTokenlineFetch)
  yield takeEvery(VERIFY_TOKEN_LINE, verifyTokenlineFetch)
  yield takeEvery(GET_TOKEN_LINE_MOBILE, getTokenlineMobileFetch)
  yield takeEvery(VERIFY_TOKEN_LINE_MOBILE, verifyTokenlineMobileFetch)
}

export default function* rootSaga() {
  yield all([fork(watchRegisterFetch)])
}